import React, { useState, useEffect } from 'react';
import { challengeService } from '../services/challengeService';
import { resolveStorageUrl } from '../utils/storageUrl';
import profile from '../images/profile.png';
import call1 from '../images/chall1.png';
import call2 from '../images/call2.png';
import call3 from '../images/chall3.png';
import './GSIDAAcademicChallenge.css';
import { supabase } from '../supabaseClient';
import APSISSection from './APSISSection';

function GSIDAAcademicChallenge({ edition: customEdition }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, [customEdition]);

  const loadData = async () => {
    try {
      setLoading(true);
      
      let editionYear = customEdition;
      if (!editionYear) {
        // Get active edition first
        const { data: activeEdition } = await supabase
          .from('editions')
          .select('year')
          .eq('is_active', true)
          .single();
        editionYear = activeEdition?.year || '2025';
      }

      const response = await challengeService.getChallengeData(editionYear);
      setData(response);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !data || !data.main.is_visible) return null;

  // If no members and no custom data has been saved (main.id won't exist if using default fallback)
  if (data.members.length === 0 && !data.main.id) return null;

  const { main, members, editionYear } = data;

  const getMemberImage = (member) => {
    return resolveStorageUrl(member?.image_url, 'speaker-images', member?.image_path) || profile;
  };

  return (
    <div className="challenge-section">
      <div className="challenge-container">
        <div className="challenge-header">
          <h1>GSIDA ACADEMIC CHALLENGE {editionYear}</h1>
          <h2 className="challenge-subtitle">{main.subtitle}</h2>
          <p className="challenge-motto">{main.motto}</p>
        </div>

        <div className="challenge-content">
          <div className="info-box">
            <h3>Objectif de la compétition</h3>
            <p>{main.objective}</p>
          </div>

          <div className="info-grid">
            <div className="info-box">
              <h3>Catégories de participation</h3>
              <p>{main.categories}</p>
            </div>

            <div className="info-box">
              <h3>Critères d’évaluation (100 points)</h3>
              <ul className="criteria-list">
                <li>Qualité scientifique – {main.criteria_quality} points</li>
                <li>Clarté, pédagogie et respect du timing – {main.criteria_clarity} points</li>
                <li>Communication et engagement – {main.criteria_social} points 
                  <span className="criteria-detail">(Facebook, Instagram, LinkedIn du congrès)</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="info-box prizes-box">
            <h3>Prix décernés :</h3>
            <ul className="prizes-list">
              {main.prizes.split(',').map((prize, idx) => (
                <p key={idx}>{prize.trim()}</p>
              ))}
            </ul>
            <div className="prizes-images">
              <img src={call1} alt="Logo 1" className="prize-logo" />
              <img src={call2} alt="Logo 2" className="prize-logo" />
              <img src={call3} alt="Logo 3" className="prize-logo" />
            </div>
          </div>

          <div className="info-box spirit-box">
            <h3>Esprit de la compétition</h3>
            <p>{main.competition_spirit}</p>
            <p className="hashtag">{main.hashtag} – Ensemble pour l’innovation académique !</p>
          </div>
        </div>

        {members.length > 0 && (
          <div className="challenge-members">
             <h3 className="challenge-members-title">Membres de la compétition</h3>
             
             {/* Special Top Member (Order 1) */}
             {members.find(m => m.display_order === 1) && (
               <div className="top-member-container">
                 {members.filter(m => m.display_order === 1).map(member => (
                   <div key={member.id} className="speaker-member challenge-speaker-member top-center-member">
                     <div className="member-photo">
                       <img
                         src={getMemberImage(member)}
                         alt={member.name}
                         onError={(e) => { e.target.onerror = null; e.target.src = profile; }}
                       />
                     </div>
                     <div className="member-infospeaker">
                       <h4>{member.name}</h4>
                       <p>{member.title}</p>
                       <p>{member.organization}</p>
                     </div>
                   </div>
                 ))}
               </div>
             )}

             <div className="members-grid">
               {members.filter(m => m.display_order !== 1).map(member => (
                 <div key={member.id} className="speaker-member challenge-speaker-member">
                   <div className="member-photo">
                     <img
                       src={getMemberImage(member)}
                       alt={member.name}
                       onError={(e) => { e.target.onerror = null; e.target.src = profile; }}
                     />
                   </div>
                   <div className="member-infospeaker">
                     <h4>{member.name}</h4>
                     <p>{member.title}</p>
                     <p>{member.organization}</p>
                   </div>
                 </div>
               ))}
             </div>
          </div>
        )}
      </div>
      <APSISSection edition={customEdition} />
    </div>
  );
}

export default GSIDAAcademicChallenge;
